import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
import { Check, Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PlanSovereign() {
  const features = ['Multi-Store Architecture Support', 'Priority Real-time Synchronization', 'Advanced Analytics & Insights Suite', 'Dedicated Account Manager', '24/7 Priority Concierge Support', 'Custom Reporting Engine', 'Unlimited History Retention', 'API Access for Custom Integrations', 'White-glove Onboarding Service', 'Quarterly Compliance Audits'];
  return <div className="min-h-screen bg-sovereign-navy text-white pt-20 pb-32 relative overflow-hidden" data-id="element-258">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-sovereign-gold via-sovereign-navy to-sovereign-navy" data-id="element-259" />

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-261">
          <div className="flex justify-center mb-6" data-id="element-262">
            <span className="bg-sovereign-gold/20 text-sovereign-gold border border-sovereign-gold/50 px-4 py-1 rounded-full text-xs uppercase tracking-widest flex items-center gap-2" data-id="element-263">
              <Star className="w-3 h-3 fill-current" data-id="element-264" />
              The Pinnacle
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-6" data-id="element-265">
            Sovereign
          </h1>
          <p className="text-xl text-gray-300 font-light max-w-2xl mx-auto" data-id="element-266">
            The ultimate compliance suite for established enterprises requiring
            uncompromising excellence.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-sovereign-navy-light p-12 border border-sovereign-gold relative overflow-hidden" data-id="element-267">
          {/* Decorative corner */}
          <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-sovereign-gold/20 to-transparent" data-id="element-268" />

          <div className="flex flex-col md:flex-row justify-between items-baseline mb-12 border-b border-white/10 pb-8" data-id="element-269">
            <div data-id="element-270">
              <span className="text-5xl font-serif text-sovereign-gold" data-id="element-271">
                KES 12,999
              </span>
              <span className="text-gray-400 ml-2 font-light" data-id="element-272">/ year</span>
            </div>
            <Link to="/contact" data-id="element-273">
              <Button variant="primary" className="mt-6 md:mt-0" data-id="element-274">
                Request Access <ArrowRight className="ml-2 h-4 w-4" data-id="element-275" />
              </Button>
            </Link>
          </div>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-276">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4 + index * 0.1
          }} className="flex items-start gap-3" data-id="element-277">
                <Check className="w-5 h-5 text-sovereign-gold mt-0.5 flex-shrink-0" data-id="element-278" />
                <span className="text-gray-300 font-light" data-id="element-279">{feature}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}